import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 3.75H2a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 0 1.5Zm-.61 7.51V5.93a.76.76 0 0 0-.75-.75H3.37a.76.76 0 0 0-.75.75v5.33A2.27 2.27 0 0 0 5 13.75h6a2.26 2.26 0 0 0 2.39-2.49Zm-1.5-4.58v4.58c0 .87-.42 1-.88 1H5c-.46 0-.89-.12-.89-1V6.68ZM10 8.84a.75.75 0 0 0-.75-.75H6.73a.75.75 0 0 0 0 1.5h2.56a.75.75 0 0 0 .71-.75Z';
const draw24px =
  'M22,5.52H2A.75.75,0,0,1,2,4H22a.75.75,0,0,1,0,1.5ZM20.46,17.11V8.23a.74.74,0,0,0-.75-.75H4.28a.74.74,0,0,0-.75.75v8.88c0,2.28,1.29,3.64,3.47,3.64H17C19.17,20.75,20.46,19.39,20.46,17.11ZM19,9v8.13c0,1.44-.64,2.14-2,2.14H7c-1.33,0-2-.7-2-2.14V9Zm-3.71,3.58a.75.75,0,0,0-.75-.75h-5a.75.75,0,0,0,0,1.5h5A.74.74,0,0,0,15.25,12.56Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const StorageBoxIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'storageBox'),
) as IconWithRender;

StorageBoxIcon.displayName = 'StorageBoxIcon';
StorageBoxIcon.propTypes = Icon.propTypes;
StorageBoxIcon.renderIcon = (props) => <StorageBoxIcon {...props} />;
export default StorageBoxIcon;
